/* Source: src/mt-includes/widgets/accordion/src/frontend/init.js*/
angular.module('website.widget.accordion', []);
